import { render, staticRenderFns } from "./exam_wp.vue?vue&type=template&id=a6647c00&scoped=true&"
import script from "./exam_wp.vue?vue&type=script&lang=js&"
export * from "./exam_wp.vue?vue&type=script&lang=js&"
import style0 from "./exam_wp.vue?vue&type=style&index=0&id=a6647c00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6647c00",
  null
  
)

export default component.exports